

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import {tireStoringInfoService} from '@/services';
import {ResponseCodeEnum} from '@/models';

@Component
export default class QrcodeReader extends Vue {
  @Prop() public multiple!: boolean;
  @Prop() public isScanTire!: boolean;
  @Prop() public showLabel!: boolean;
  @Prop() public contractScan!: boolean;
  



  private error: string = '';
  private isError: boolean = false;
  private results: string[] = [];

  private onInit(promise: Promise<any>) {
    promise.catch((error) => {
      this.isError = true;
      if (error.name === 'NotAllowedError') {
        this.error = 'common.message.camera_access';
      } else if (error.name === 'NotFoundError') {
        this.error = 'common.message.camera_not_found';
      } else if (error.name === 'NotSupportedError') {
        this.error = 'common.message.required_secure_context';
      } else if (error.name === 'NotReadableError') {
        this.error = 'common.message.camera_in_use';
      } else if (error.name === 'OverconstrainedError') {
        this.error = 'common.message.camera_not_suitable';
      } else if (error.name === 'StreamApiNotSupportedError') {
        this.error = 'common.message.stream_api_not_supported';
      } else {
        this.error = error.name;
      }
    });
  }

  private onDecode(result: string) {
    if(result) {
      if (this.multiple) {
        const newArray = this.results;
        newArray.push(result);
        this.results = [...new Set(newArray)];
      } else if(this.contractScan) {
        tireStoringInfoService.getSelectedContractByOneTireIds([result])
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            const selectedContractIds: string[] = res.data.data;
            this.results = selectedContractIds;
          }
        });
      }  else {
        this.results = [result];
      }
    } 
  }

  private removeItem(index: number) {
    this.results.splice(index, 1);
  }

  private close() {
    if(this.showLabel) {
      this.$emit("close", true);
    } else {
      this.results = [];
      this.$emit('onDecode', undefined);
    }
  }


  private confirm() {
    if (this.multiple) {
      const result = this.results.join();
      this.$emit('onDecode', result);
    } else if (this.results[this.results.length - 1]) {
      const result = this.results[this.results.length - 1];
      this.$emit('onDecode', result);
    } else {
      this.$emit('onDecode', undefined);
    }
    this.results = [];
  }

}
